import { Suspense, lazy, type ComponentType } from 'react';
import { useSettings } from '@/hooks/useSettings';

/**
 * SHIFT BANNER SLOT (filled by the shifts screen agent).
 * Create `src/features/shifts/ShiftBanner.tsx` with a default-exported component; it is rendered here
 * (top of every page, every role) whenever `shifts_enabled` is true. Until then nothing renders.
 * The component decides for itself what each role sees.
 */
const modules = import.meta.glob<{ default: ComponentType }>(
  '../../features/shifts/ShiftBanner.tsx',
);
const loader = Object.values(modules)[0];
const ShiftBanner = loader ? lazy(loader) : null;

export function ShiftBannerSlot() {
  const { settings } = useSettings();
  if (!ShiftBanner || !settings.shifts_enabled) return null;
  return (
    <Suspense fallback={null}>
      <ShiftBanner />
    </Suspense>
  );
}
